// extracted by mini-css-extract-plugin
export default {"container":"Pj-z","blurb":"Qj-z","links":"Rj-z"};